const r = {};
function i(t, c, a) {
  const o = `${t}|${c}|${a}`, h = r[o];
  if (h !== void 0)
    return h;
  const n = fetch(
    `https://edge.api.brightcove.com/playback/v1/accounts/${t}/${a}`,
    {
      headers: { accept: `application/json;pk=${c}` },
      method: "GET"
    }
  ).then((e) => {
    if (!e.ok)
      throw new Error(`Brightcove request failed: ${e.status}`);
    return e.json();
  }).catch((e) => {
    throw delete r[o], e;
  });
  return r[o] = n, n;
}
function s(t, c) {
  return t ? `videos/${t}` : `playlists/${c}`;
}
export {
  i as fetchBrightcoveData,
  s as getVideoResourceUrl
};
//# sourceMappingURL=fetchBrightcoveData.mjs.map
